import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useIntl } from "react-intl";

//Components
import { Container, Breadcrumb, Loading } from "@gpstrackit/gtc-react-controls";
import { Tabs, TabContainer } from "@gpstrackit/gtc-react-controls";
import { Grid, Paper } from '@mui/material';

// Views
import FunctionTab from '../functionTab';
import RiskEventsTab from '../riskEventsTab';

const CustomerDetail = () => {

    const { messages } = useIntl()

    //Hooks
    const navigate = useNavigate();
    const tabRef = useRef();

    // Params
    const [tab, setTab] = useState(0);

    // Redux States
    const { loadingConfigs } = useSelector((state) => state.driverPerformanceFunctionTabRedux);

    // Tabs
    const tabs = [
        {
            label: messages['driverPerformanceConfig_riskEvents'],
            id: "riskEvents",
            component: <RiskEventsTab />,
        },
        {
            label: messages['driverPerformanceConfig_functions'],
            id: "functions",
            component: <FunctionTab />,
        }
    ];

    return (
        <Container className="container-view">
            {(loadingConfigs) && <Loading overlay show />}
            <Paper elevation={0}>
                <Grid
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    style={{ padding: "15px 20px" }}
                >
                    <Grid item xs>
                        <Breadcrumb
                            links={[
                                {
                                    title: `${messages['driverPerformanceConfig_dashboard']}`,
                                    link: "/app/driverPerformance",
                                },
                                {
                                    title: `${messages['driverPerformanceConfig_functions']}`
                                },
                            ]}
                            navigate={navigate}
                        />
                    </Grid>
                    <Grid item xs style={{ display: 'flex', justifyContent: 'end' }}>

                    </Grid>
                </Grid>
                <div className="case-details-tabs">
                    <Tabs
                        ref={tabRef}
                        tab={tab}
                        onChange={(value) => setTab(value)}
                    >
                        {tabs.map((item, index) => {
                            const { label, component } = item;
                            return (
                                <TabContainer key={index} label={label} index={index}>
                                    {component}
                                </TabContainer>
                            );
                        })}
                    </Tabs>
                </div>
            </Paper>
        </Container>
    )
}

export default CustomerDetail
